import { DraggableNode } from './draggableNode';

const nodeConfig = [
  { type: 'customInput',  label: 'Input',     color: '#6366f1' },
  { type: 'llm',          label: 'LLM',       color: '#8b5cf6' },
  { type: 'customOutput', label: 'Output',    color: '#10b981' },
  { type: 'text',         label: 'Text',      color: '#f59e0b' },
  { type: 'filter',       label: 'Filter',    color: '#ef4444' },
  { type: 'transform',    label: 'Transform', color: '#0ea5e9' },
  { type: 'condition',    label: 'Condition', color: '#f97316' },
  { type: 'note',         label: 'Note',      color: '#84cc16' },
  { type: 'api',          label: 'API Call',  color: '#06b6d4' },
];

export const PipelineToolbar = () => {
  return (
    <div style={{
      background: '#ffffff', // Clean professional white
      borderBottom: '1px solid #e2e8f0',
      padding: '16px 24px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between', // Pushes brand to left, nodes to right/center
      flexWrap: 'wrap',
      gap: 20,
      boxShadow: '0 1px 3px rgba(0,0,0,0.05)', // Subtle drop shadow
      zIndex: 10,
      position: 'relative'
    }}>
      {/* Brand Identity */}
      <div style={{
        color: '#0f172a',
        fontWeight: 700,
        fontSize: 16,
        letterSpacing: '-0.01em',
        fontFamily: '"Inter", "Segoe UI", sans-serif',
        display: 'flex',
        alignItems: 'center',
        gap: 8,
      }}>
        <span style={{ color: '#6366f1', fontSize: 20 }}>⬡</span> 
        VectorShift
      </div>

      {/* Node Buttons Container */}
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, justifyContent: 'center' }}>
        {nodeConfig.map((n) => (
          <DraggableNode key={n.type} type={n.type} label={n.label} color={n.color} />
        ))}
      </div>
    </div>
  );
};